<template>
  <div id="user-signin">
    <button v-if="!currentUser" @click="login" class="primary">Login</button>
    <template v-if="currentUser">
      <span>{{ currentUser.name }}</span>
      <button @click="logout" class="outline thin">
        <v-icon name="sign-out-alt" />
      </button>
    </template>
  </div>
</template>

<script>
export default {
  name: "UserSignin",
  methods: {
    login() {
      this.$store.dispatch("login");
    },
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
</script>

<style scoped lang="less">
@import "../styles/vars";

#user-signin {
  display: flex;
  align-items: center;
  padding: 0 @h1;
  font-size: 0.75rem;
  span {
    margin: 0 @h1;
  }
}
</style>
